import globalTagsStore from '../components/Tag/globalTags.store';

function provideTerms() {
    return {
        tags: globalTagsStore.getTags()
    };
}

export default {
    provideTerms
};
